import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"wip, work, barrier"} maskId="square-filled-radius-0-stroke-1-IconWip"><path fillRule="evenodd" clipRule="evenodd" d="M7 4V2H6V4H2V14H6V21H4V22H9V21H7V14H17V21H15V22H20V21H18V14H22V4H18V2H17V4H7ZM6.03382 13H4.96582L7.96582 5H9.03382L6.03382 13ZM9.96582 13L12.9658 5H14.0338L11.0338 13H9.96582ZM14.9658 13L17.9658 5H19.0338L16.0338 13H14.9658Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconWip;
